import { Component, OnInit, Inject, signal } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';

import { SAVE_DIALOG_LOCAL_STORAGE_KEY } from './saved-views.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
export interface SaveDialogData {
  onSave: (formData: any) => Promise<any>;
}

@Component({
  selector: 'rdo-saved-views-save-dialog',
  styleUrls: ['./saved-views-dialogs.component.scss'],
  template: `
    <div [id]="gridName" class="saved-views-dialog">
      <form [formGroup]="form" class="dialog-form">
        <h2 mat-dialog-title class="header">
          {{ 'main.saved_views.dialogs.save.title' | translate }}
        </h2>
        <div mat-dialog-content class="content">
          <p>{{ getMessage() }}</p>
          <div></div>
          @if (isSaving()) {
            <div class="saving-indicator">
              <div class="rdo-loader">
                <img
                  src="/assets/images/loader-sm.gif"
                  width="20"
                  height="20"
                />
              </div>
            </div>
          }
          @if (errorMessage()) {
            <div class="error-message">
              <i class="fa fa-exclamation-circle"></i>{{ errorMessage() }}
            </div>
          }
        </div>
        <div mat-dialog-actions class="actions">
          <div class="actions-left">
            <label class="checkbox-label">
              <input
                type="checkbox"
                class="checkbox"
                formControlName="hide"
                [disabled]="isSaving()"
              />{{ 'main.saved_views.dialogs.save.checkbox_label' | translate }}
            </label>
          </div>
          <div class="actions-right">
            <button
              mat-button
              class="btn"
              (click)="onOkClick()"
              [disabled]="isSaving()"
            >
              @if (isSaving()) {
                <i class="fa fa-spinner fa-spin"></i>
              }
              {{ isSaving() ? '' : 'Ok' }}
            </button>
            <button
              mat-button
              mat-dialog-close
              class="btn"
              [disabled]="isSaving()"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  `,
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class SavedViewsSaveDialogComponent implements OnInit {
  public gridName: string = 'SavedViewsSaveDialog';
  public form: FormGroup;
  public isSaving = signal(false);
  public errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<SavedViewsSaveDialogComponent>,
    protected translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: SaveDialogData
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      hide: new FormControl(false),
    });
  }

  async onOkClick(): Promise<void> {
    if (!this.isSaving()) {
      const formData = this.form.value;
      this.isSaving.set(true);
      this.errorMessage.set('');

      try {
        window.localStorage.setItem(
          SAVE_DIALOG_LOCAL_STORAGE_KEY,
          `${!formData.hide}`
        );

        if (this.data && this.data.onSave) {
          await this.data.onSave(formData);
        }

        // Close dialog on success
        this.dialogRef.close({ success: true, ...formData });
      } catch (error) {
        this.isSaving.set(false);
        this.errorMessage.set(
          error.message || 'Failed to save. Please try again.'
        );
        console.error('Save error:', error);
      }
    }
  }

  getMessage(): string {
    return this.translateService.instant(
      'main.saved_views.dialogs.save.message',
      { report_name: 'All Sales Reps by Difference to Bench' }
    );
  }
}
